export class ShowExclusionModalPayload {
  compSearchId: number;
}
